import { MessageCircle } from "lucide-react";

const FloatingWhatsApp = () => {
  return (
    <a
      href="https://wa.me/918800095625?text=Hi%2C%20I%20want%20to%20book%20a%20consultation%20for%20Diastasis%20Recti%20Treatment"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 bg-[#25D366] text-white p-4 rounded-full shadow-2xl z-50 hover:scale-110 transition-transform duration-300 flex items-center justify-center whatsapp-pulse"
      aria-label="Chat on WhatsApp"
      data-testid="floating-whatsapp-btn"
    >
      <MessageCircle size={28} fill="currentColor" />
    </a>
  );
};

export default FloatingWhatsApp;
